// extracted by mini-css-extract-plugin
export default {"security-type-form-component":"security-type-and-form_security-type-form-component__jn9Uk","btn-actions":"security-type-and-form_btn-actions__g6Ghh"};